'use client'

import { Box } from '@chakra-ui/react'

type ShimmerProgressBarProps = {
  percentage: number
  width?: string
  height?: string
  color?: string
  onDoubleClick?: () => void
  backgroundColor?: string
  borderRadius?: string
  hasGradient?: boolean
}

const ShimmerProgressBar = ({
  percentage,
  width = '100%',
  height = '4',
  color = 'blue.500',
  onDoubleClick,
  backgroundColor = 'white',
  borderRadius = '1px',
  hasGradient = true,
}: ShimmerProgressBarProps) => (
  <Box height={height} position="relative" width={width}>
    <Box
      backgroundColor={backgroundColor}
      borderRadius={borderRadius}
      height="100%"
      position="absolute"
      width={width}
      onDoubleClick={onDoubleClick}
    >
      <Box
        backgroundColor={color}
        borderRadius={borderRadius}
        height="100%"
        style={{
          transition: 'width 1s',
          width: `${percentage}%`,
        }}
      />
    </Box>
    {hasGradient && (
      <Box
        borderRadius={borderRadius}
        height="100%"
        position="absolute"
        style={{
          backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.5) , rgba(255, 255, 255, 0) 60%)`,
        }}
        width={width}
        onDoubleClick={onDoubleClick}
      />
    )}
  </Box>
)

export default ShimmerProgressBar
